import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface AuthContextType {
  accessToken: string;
  setAccessToken: (value: string) => void;
}

const AuthContext = createContext<AuthContextType>({
  accessToken: '',
  setAccessToken: () => {},
});

export function AuthContextProvider({ children }: PropsWithChildren) {
  const [accessToken, setAccessToken] = useState<string>(localStorage.getItem('access_token') ?? '');

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        setAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  return context;
};
